import { UploadedFile } from '@shared/models/uploaded-file'

export function toUploadedFile(file: UploadedFile): UploadedFile {
  return new UploadedFile(file)
}
